import styled from "styled-components";

export const Selfie = styled.img`
	align-self: center;
	width: 175px;
	height: 175px;
	border-radius: 50%;
	margin: 10px;
`;

export const ProjectPreview = styled.img`
	max-width: 100%;
	max-height: 200px;
	border-radius: 15px;
`;
